var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDvc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000001663591201793863770000009249541531041707660_);}\r\n\t.st2{fill:url(#SVGID_00000070827813083755475130000005160874139924983474_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.4237,
    y1: 7.1544,
    x2: 7.475,
    y2: 7.1544,
    gradientTransform: "matrix(3.699352e-15 60.415 -60.415 3.699352e-15 838.6373 -104.9413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F46837"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DD5236"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.39,310.72c-24.32-24.07-35.58-53.24-35.58-87.64c0-34.6,11.2-63.9,35.58-88.16 c11.58-11.8,25.44-21.13,40.73-27.43c15.21-6.25,31.53-9.32,47.97-9.01c30.96-0.52,60.97,10.93,84.03,32.05 c3.52,3.27,3.59,6.54,0.39,9.68l-27.07,27.93c-3.01,2.75-5.95,2.75-8.7,0c-12.96-11.62-29.68-17.89-46.91-17.59 c-19.46,0-35.65,6.93-48.64,20.93c-6.21,6.69-11.03,14.55-14.2,23.11c-3.19,8.61-4.67,17.75-4.36,26.93 c0,19.36,5.76,35.84,18.82,49.51c6.26,6.66,13.85,11.93,22.28,15.48c8.38,3.52,17.41,5.22,26.49,4.99 c16.95,0.39,33.47-5.49,46.53-16.55c3.2-2.75,6.21-2.62,8.96,0.33l27.14,28.65c3.01,3.01,2.88,6.08-0.32,9.29 c-22.71,22.1-53.06,34.12-84.42,33.42c-16.4,0.32-32.7-2.69-47.9-8.86c-15.28-6.21-29.16-15.43-40.81-27.11V310.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170989546090454651600000008998678311368435621_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.4221,
    y1: 9.7225,
    x2: 7.4733,
    y2: 9.7225,
    gradientTransform: "matrix(3.689004e-15 60.246 -60.246 3.689004e-15 690.6379 -103.9273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#13ADC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1497B8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170989546090454651600000008998678311368435621_)"
    },
    d: "M0,339.44V105.29 c-0.03-0.89,0.13-1.77,0.46-2.6c0.33-0.82,0.83-1.57,1.46-2.17c1.07-1.25,2.64-1.97,4.29-1.96h83.65 c34.3,2.62,59.9,12.42,83.46,36.63c23.68,24.2,33.09,51.67,36.09,86.99c2.88,34.01-11.01,63.44-34.56,87.64 c-10.9,11.68-24.1,20.97-38.78,27.29c-14.59,6.27-30.34,9.41-46.22,9.21H6.21c-0.81,0-1.61-0.18-2.35-0.52 c-0.74-0.34-1.4-0.83-1.94-1.44c-0.64-0.63-1.14-1.38-1.46-2.21c-0.33-0.84-0.49-1.73-0.46-2.63L0,339.44L0,339.44z M53.51,162.19 v131.66h32.9c19.2,0,35.2-6.93,47.87-20.73c12.67-13.78,19.5-32.11,19.01-51.02c0-20.08-6.4-37.02-19.01-50.82 c-6.04-6.72-13.46-12.06-21.74-15.66c-8.24-3.57-17.15-5.3-26.13-5.08h-32.9V162.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085956409724522183720000013091185640970623398_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.0358,
    y1: 8.5688,
    x2: 8.0871,
    y2: 8.5688,
    gradientTransform: "matrix(3.514247e-15 57.392 -57.392 3.514247e-15 746.6033 -51.7294)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7E51C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#945DD6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085956409724522183720000013091185640970623398_)"
    },
    d: "M307.52,180.43l-51.84,116.42h-2.11 l-55.36-124.53c6.27,14.91,9.6,31.26,11.2,49.77c2.11,24.85-4.73,47.22-17.73,66.97l55.04,120.54c1.41,2.62,3.33,3.92,5.89,3.92 h3.46c2.56,0,4.48-1.24,5.82-3.86l56.07-121.98c-11.67-19.44-17.62-41.89-17.15-64.69C300.8,207.84,302.98,193.58,307.52,180.43 L307.52,180.43z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvc);
export default __webpack_public_path__ + "static/media/dvc.327c68f942f43a5e63e1b0b13c4c75a1.svg";
export { ForwardRef as ReactComponent };